export default "__VITE_ASSET__CaB9zvoX__"